@if (isLoading()) {
  <div class="grid">
    @for (item of [] | range: placeholderCount(); track item) {
      <smw-card-skeleton-loader />
    }
  </div>
} @else {
  @if (isEmpty()) {
    <div class="empty">
      <ng-content select="[empty-message]" />
    </div>
  } @else {
    <div class="grid">
      <ng-content select="[items]" />
    </div>
  }
}
